import { render, staticRenderFns } from "./SideBarItem.vue?vue&type=template&id=1d4c54f5&"
import script from "./SideBarItem.vue?vue&type=script&lang=ts&"
export * from "./SideBarItem.vue?vue&type=script&lang=ts&"
import style0 from "./SideBarItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports